// extracted by mini-css-extract-plugin
export default {"label":"FormFile_label__P4bSy","input":"FormFile_input__3C9B0","labelV2":"FormFile_labelV2__923SP","labelColorV3":"FormFile_labelColorV3__GQFan","icon":"FormFile_icon__yrwEb"};